// extracted by mini-css-extract-plugin
module.exports = {"item":"companionInputGroupItem_item__hJ7_i","icon":"companionInputGroupItem_icon__gq_33"};